import { render, staticRenderFns } from "./CalendargroupFields.vue?vue&type=template&id=b56305a6"
import script from "./CalendargroupFields.vue?vue&type=script&lang=js"
export * from "./CalendargroupFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports